import { HttpClient } from '@angular/common/http'
import { inject, Injectable, Type } from '@angular/core'
import { catchError, Observable, of, throwError } from 'rxjs'
import { CityList } from '../../components/city-list/city-list'
import { Centered3By3Grid } from '../../blocks/centered-3-by-3-grid/centered-3-by-3-grid'
import { PageContent } from '../../intefaces/interfaces'
import { environment } from '../../../../environments/environment'
import { HeaderWithFloatingOfferForm } from '../../blocks/header-with-floating-offer-form/header-with-floating-offer-form'
import { FeatureListWithImage } from '../../blocks/feature-list-with-image/feature-list-with-image'
import { FeatureWithCenteredImage } from '../../blocks/feature-with-centered-image/feature-with-centered-image'
import { CustomerReviews } from '../../blocks/customer-reviews/customer-reviews'
import { CtaBannerGradientBg } from '../../blocks/cta-banner-gradient-bg/cta-banner-gradient-bg'
import { HeaderInCard } from '../../blocks/header-in-card/header-in-card'
import { Feature2ColumnsWithIconLine } from '../../blocks/feature-2-columns-with-icon-line/feature-2-columns-with-icon-line'
import { StatsMin3Columns } from '../../blocks/stats-min-3-columns/stats-min-3-columns'
import { ThreeCardsWithImages } from '../../blocks/three-cards-with-images/three-cards-with-images'
import { FaqWithContactCard } from '../../blocks/faq-with-contact-card/faq-with-contact-card'
import { FeatureCopyWithImageRight } from '../../blocks/feature-copy-with-image-right/feature-copy-with-image-right'
import { LogoCloudColoredBg } from '../../blocks/logo-cloud-colored-bg/logo-cloud-colored-bg'
import { HeroTwoColumnAligned } from '../../blocks/hero-two-column-aligned/hero-two-column-aligned'
import { FeatureWithSubFeaturesAndImage } from '../../blocks/feature-with-sub-features-and-image/feature-with-sub-features-and-image'
import { FeatureTimeline } from '../../blocks/feature-timeline/feature-timeline'
import { FeatureCentered2By2Grid } from '../../blocks/feature-centered-2-by-2-grid/feature-centered-2-by-2-grid'
import { Router } from '@angular/router'

const componentMap: { [key: string]: Type<any> } = {
	Centered3By3Grid: Centered3By3Grid,
	CityList: CityList,
	HeaderWithFloatingOfferForm: HeaderWithFloatingOfferForm,
	FeatureListWithImage: FeatureListWithImage,
	FeatureWithCenteredImage: FeatureWithCenteredImage,
	CustomerReviews: CustomerReviews,
	CtaBannerGradientBg: CtaBannerGradientBg,
	HeaderInCard: HeaderInCard,
	Feature2ColumnsWithIconLine: Feature2ColumnsWithIconLine,
	StatsMin3Columns: StatsMin3Columns,
	ThreeCardsWithImages: ThreeCardsWithImages,
	FaqWithContactCard: FaqWithContactCard,
	FeatureCopyWithImageRight: FeatureCopyWithImageRight,
	LogoCloudColoredBg: LogoCloudColoredBg,
	HeroTwoColumnAligned: HeroTwoColumnAligned,
	FeatureWithSubFeaturesAndImage: FeatureWithSubFeaturesAndImage,
	FeatureTimeline: FeatureTimeline,
	FeatureCentered2By2Grid: FeatureCentered2By2Grid,
}

@Injectable({
	providedIn: 'root',
})
export class CustomContent {
	webStorageUrl = environment.webStorageUrl

	private http = inject(HttpClient)
	private route = inject(Router)

	public getPageContent(path: string): Observable<any> {
		return this.http
			.get<PageContent>(`${this.webStorageUrl}/custom-content/RadiusAuto/page-content/en-US/${path}.json`)
	}

	public getCityContent(city: string, stateAbv: string): Observable<any> {
		return this.http
			.get<PageContent>(
				`${this.webStorageUrl}/custom-content/RadiusAuto/state-content/${stateAbv}/city-content/en-US/${city}.json`,
			)
			.pipe(
				catchError((error) => {
					if (error.status === 404) {
						return this.route.navigate(['sell-my-car'])
					} else {
						return throwError(() => new Error('City Content Not Found!'))
					}
				}),
			)
	}

	public getStateContent(stateAbv: string): Observable<any> {
		return this.http
			.get<PageContent>(`${this.webStorageUrl}/custom-content/RadiusAuto/state-content/en-US/${stateAbv}.json`)
			.pipe(
				catchError((error) => {
					if (error.status === 404) {
						return this.route.navigate(['sell-my-car'])
					} else {
						return throwError(() => new Error('State Content Not Found!'))
					}
				}),
			)
	}

	public getListOfStatesAndCities(): Observable<any> {
		return this.http.get<any>(`${this.webStorageUrl}/custom-content/RadiusAuto/data/en-US/states.json`)
	}

	public mapToComponentType(componentName: string) {
		const componentType = componentMap[componentName]
		if (!componentType) return
		return componentType
	}
}
